module.exports = __webpack_public_path__ + "static/media/gen_fir_gro.7e2e2039.png";